var _path, _rect, _path2, _path3, _path4, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIntegrity = function SvgIntegrity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6C9BF1",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M35 60V11"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 7,
    x: 19,
    y: 59,
    fill: "#2F68D1",
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    d: "M23.999 34c1.104 0 2.021.905 1.806 1.988C24.784 41.114 19.887 45 14 45S3.216 41.114 2.195 35.988C1.98 34.905 2.897 34 4.001 34zM65.999 34c1.104 0 2.021.905 1.806 1.988C66.784 41.114 61.887 45 56 45s-10.784-3.886-11.805-9.012C43.98 34.905 44.897 34 46.001 34z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFD2A8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m23 35-9-24-9 24M65 35l-9-24-9 24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2F68D1",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M14 11h42"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35,
    cy: 10.5,
    fill: "#2F68D1",
    rx: 4,
    ry: 4.5
  })));
};
export default SvgIntegrity;